<div class="h-screen flex align-items-center justify-content-center flex-column">
  <h1>{{ 'PAGES.PAGE_NOT_FOUND.TITLE' | translate }}</h1>
  <div class="flex">
    <button
      pButton
      icon="fa fa-arrow-left"
      (click)="goTo(true)"
      iconPos="left"
      label="{{ 'BUTTONS.GO_BACK' | translate }}"
      class="p-button-text mr-3"
    ></button>
    <button
      *ngIf="authService.isLoggedIn"
      pButton
      icon="fa fa-home"
      (click)="goTo()"
      iconPos="left"
      label="{{ 'BUTTONS.GO_HOME' | translate }}"
    ></button>
  </div>
</div>
